module.exports = __webpack_public_path__ + "static/index/img/baikal-409.875a7a7b.jpg";